import { render } from "./NavItemMobile.vue?vue&type=template&id=003e958c&scoped=true"
import script from "./NavItemMobile.vue?vue&type=script&lang=js"
export * from "./NavItemMobile.vue?vue&type=script&lang=js"

import "./NavItemMobile.vue?vue&type=style&index=0&id=003e958c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-003e958c"

export default script